import React, { useEffect, useState, useContext } from 'react';
import { Table, Space } from 'antd';
import AddSeason from '../components/AddSeason';
import { generateSeasonCols, seasonCols } from '../utils/DataUtils';
import { api } from '../AppConfig';
import * as Setting from '../utils/AuthUtils';
import { motion } from 'motion/react';
import { useTranslation } from 'react-i18next';
import { MeContext } from '../context';

function Seasons(props) {
    const [error, setError] = useState(null);
    const [isLoaded, setIsLoaded] = useState(false);
    const [items, setItems] = useState([]);
    const [leagues, setLeagues] = useState([]);
    const [isAdmin, setIsAdmin] = useState(false);
    const me = useContext(MeContext);
    const { t } = useTranslation();

    useEffect(() => {
        const isAd = (me && me.payLoad ? me.payLoad.isAdmin : false)
        setIsAdmin(isAd);
        fetch(api.seasons().list().href, {
          headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + Setting.getToken(),
            // 'Content-Type': 'application/x-www-form-urlencoded',
          },
        })
          .then(res => res.json())
          .then(
            (result) => {
              setIsLoaded(true);
              setItems(result.payLoad);
            },
            // Note: it's important to handle errors here
            // instead of a catch() block so that we don't swallow
            // exceptions from actual bugs in components.
            (error) => {
              setIsLoaded(true);
              setError(error);
            }
          )
        fetch(api.leagues().list().href)
          .then(res => res.json())
          .then(
            (result) => {
              setIsLoaded(true);
              setLeagues(result.payLoad);
            },
            (error) => {
              setIsLoaded(true);
              setError(error);
            }
          )
      }, [me])

      return (
        <motion.div initial={{opacity: 0}} animate={{opacity: 1}} exit={{opacity: 0}} className="content-body">
        <h1>
            {t('seasons.title')}
        </h1>
        <Table
            rowClassName={(record, index) => index % 2 === 0 ? 'table-row-light' :  'table-row-dark'}
            size="small"
            columns={generateSeasonCols(t)} 
            dataSource={items} 
            pagination={false} 
            loading={!isLoaded}/>
            { Setting.isLoggedIn() && isAdmin &&
              <AddSeason leagues={leagues} />
            }
        </motion.div>
    );
}

export default Seasons;